export default "__VITE_ASSET__ZSm9dGXR__"